import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getMakaniDetails } from '../services/Common';
import { Loader } from './utils';
const Navbar = ({
  sideMenu,
  appDir,
  dirCallBack,
  sideMenuCallback,
  onLatLngSearch,
}) => {
  const { t, i18n } = useTranslation();
  const [latValue, setLatValue] = useState('');
  const [lngValue, setLngValue] = useState('');
  const [makaniValue, setMakaniValue] = useState('');
  const [makaniLoading, setMakaniLoading] = useState(false);
  const openSideBar = () => {
    sideMenuCallback(!sideMenu);
  };
  const changeLanguage = () => {
    let lang = 'en';
    if (window.localStorage.getItem('lang'))
      lang = window.localStorage.getItem('lang');
    if (lang === 'en') {
      dirCallBack('rtl');
      i18n.changeLanguage('ar');
      window.localStorage.setItem('lang', 'ar');
    } else {
      // document.body.dir = 'ltr';
      dirCallBack('ltr');
      i18n.changeLanguage('en');
      window.localStorage.setItem('lang', 'en');
    }
  };
  const handleLatLngSubmit = (e) => {
    e.preventDefault();
    const lat = parseFloat(latValue);
    const lng = parseFloat(lngValue);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    if (onLatLngSearch) onLatLngSearch({ lat, lng, autoOpen: false });
  };
  const handleLatChange = (e) => {
    const value = e.target.value;
    if (value.includes(',')) {
      const [latPart, lngPart] = value.split(',');
      setLatValue(latPart.trim());
      if (lngPart !== undefined) setLngValue(lngPart.trim());
      return;
    }
    setLatValue(value);
  };
  const handleMakaniSubmit = (e) => {
    e.preventDefault();
    if (!makaniValue || makaniLoading) return;
    const normalizeMakani = (value) => {
      const trimmed = value.trim();
      if (/\s/.test(trimmed)) return trimmed;
      const digitsOnly = trimmed.replace(/\s+/g, '');
      if (digitsOnly.length <= 5) return digitsOnly;
      return `${digitsOnly.slice(0, 5)} ${digitsOnly.slice(5)}`;
    };
    const normalizedMakani = normalizeMakani(makaniValue);
    const normalizedMakaniDigits = normalizedMakani.replace(/\s+/g, '');
    setMakaniLoading(true);
    getMakaniDetails(normalizedMakani)
      .then((data) => {
        const latLng = data?.MAKANI_INFO?.[0]?.LATLNG;
        if (!latLng) return;
        const [latPart, lngPart] = latLng.split(',');
        const lat = parseFloat(latPart);
        const lng = parseFloat(lngPart);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
        if (onLatLngSearch) {
          onLatLngSearch({
            lat,
            lng,
            autoOpen: true,
            makaniNumber: normalizedMakaniDigits,
          });
        }
      })
      .finally(() => {
        setMakaniLoading(false);
      });
  };

  return (
    <nav className='fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700'>
      <div className='px-3 py-3 lg:px-5 lg:pl-3'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center justify-start'>
            <button
              id='toggleSidebarMobile'
              onClick={openSideBar}
              className='p-2 text-gray-600 rounded cursor-pointer   hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 dark:focus:bg-gray-700 focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'>
              <svg
                id='toggleSidebarMobileHamburger'
                className={` w-6 h-6 ${sideMenu ? 'hidden' : 'flex'}`}
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  d='M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z'
                  clipRule='evenodd'></path>
              </svg>
              <svg
                id='toggleSidebarMobileClose'
                className={` w-6 h-6 ${!sideMenu ? 'hidden' : 'flex'}`}
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                  clipRule='evenodd'></path>
              </svg>
            </button>
            <a href='/' className='flex ml-2 md:mr-24'>
              <img
                src='./images/Dc-white.png'
                className='h-8 mr-3'
                alt='Logo'
              />
            </a>
            <form
              onSubmit={handleLatLngSubmit}
              className='flex items-center gap-2 lg:pl-3.5'>
              <label htmlFor='topbar-lat' className='sr-only'>
                {t('Search')}
              </label>
              <input
                type='text'
                name='lat'
                id='topbar-lat'
                dir={appDir}
                value={latValue}
                onChange={handleLatChange}
                className='bg-gray-50 shadow border border-gray-200 rounded-[70px] text-gray-900 sm:text-sm focus:ring-primary-500 focus:border-primary-500 block w-32 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                placeholder='Lat'
              />
              <input
                type='text'
                name='lng'
                id='topbar-lng'
                dir={appDir}
                value={lngValue}
                onChange={(e) => setLngValue(e.target.value)}
                className='bg-gray-50 shadow border border-gray-200 rounded-[70px] text-gray-900 sm:text-sm focus:ring-primary-500 focus:border-primary-500 block w-32 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                placeholder='Lng'
              />
              <button
                type='submit'
                className='px-4 py-2 text-sm text-white bg-red-600 rounded-[70px] hover:bg-red-700'>
                {t('Search')}
              </button>
            </form>
          </div>
          <div className='flex items-center gap-2'>
            <button
              id='toggleSidebarMobileSearch'
              type='button'
              className='p-2 text-gray-500 rounded-lg lg:hidden hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white'>
              <span className='sr-only'>{t('Search')}</span>

              <svg
                className='w-6 h-6'
                fill='currentColor'
                viewBox='0 0 20 20'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  fillRule='evenodd'
                  d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
                  clipRule='evenodd'></path>
              </svg>
            </button>
            <form
              onSubmit={handleMakaniSubmit}
              className='hidden lg:flex items-center gap-2'>
              <input
                type='text'
                name='makani'
                id='topbar-makani'
                dir={appDir}
                value={makaniValue}
                onChange={(e) => setMakaniValue(e.target.value)}
                className='bg-gray-50 shadow border border-gray-200 rounded-[70px] text-gray-900 sm:text-sm focus:ring-primary-500 focus:border-primary-500 block w-40 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500'
                placeholder='Makani'
              />
              <button
                type='submit'
                disabled={makaniLoading}
                className={`px-4 py-2 text-sm text-white rounded-[70px] ${
                  makaniLoading
                    ? 'bg-red-400 cursor-not-allowed'
                    : 'bg-red-600 hover:bg-red-700'
                }`}>
                {makaniLoading ? <Loader color={'white'} /> : t('Search')}
              </button>
            </form>

            <button
              type='button'
              onClick={changeLanguage}
              className='p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700'>
              <span className='sr-only'>View notifications</span>
              {t('lang')}
            </button>
            <div className='z-20 z-50 hidden max-w-sm my-4 overflow-hidden text-base list-none bg-white divide-y divide-gray-100 rounded shadow-lg dark:divide-gray-600 dark:bg-gray-700'>
              <div className='block px-4 py-2 text-base font-medium text-center text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400'>
                Notifications
              </div>
              <div>
                <a
                  href='/'
                  className='flex px-4 py-3 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600'>
                  <div className='flex-shrink-0'>
                    <img
                      className='rounded-full w-11 h-11'
                      src='/images/users/bonnie-green.png'
                      alt='Jeseimage'
                    />
                    <div className='absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 border border-white rounded-full bg-primary-700 dark:border-gray-700'>
                      <svg
                        className='w-3 h-3 text-white'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path d='M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z'></path>
                        <path d='M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z'></path>
                      </svg>
                    </div>
                  </div>
                  <div className='w-full pl-3'>
                    <div className='text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400'>
                      New message from{' '}
                      <span className='font-semibold text-gray-900 dark:text-white'>
                        Bonnie Green
                      </span>
                      : "Hey, what's up? All set for the presentation?"
                    </div>
                    <div className='text-xs font-medium text-primary-700 dark:text-primary-400'>
                      a few moments ago
                    </div>
                  </div>
                </a>
                <a
                  href='/'
                  className='flex px-4 py-3 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600'>
                  <div className='flex-shrink-0'>
                    <img
                      className='rounded-full w-11 h-11'
                      src='/images/users/jese-leos.png'
                      alt='Jeseimage'
                    />
                    <div className='absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 bg-gray-900 border border-white rounded-full dark:border-gray-700'>
                      <svg
                        className='w-3 h-3 text-white'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path d='M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z'></path>
                      </svg>
                    </div>
                  </div>
                  <div className='w-full pl-3'>
                    <div className='text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400'>
                      <span className='font-semibold text-gray-900 dark:text-white'>
                        Jese leos
                      </span>{' '}
                      and{' '}
                      <span className='font-medium text-gray-900 dark:text-white'>
                        5 others
                      </span>{' '}
                      started following you.
                    </div>
                    <div className='text-xs font-medium text-primary-700 dark:text-primary-400'>
                      10 minutes ago
                    </div>
                  </div>
                </a>
                <a
                  href='/'
                  className='flex px-4 py-3 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600'>
                  <div className='flex-shrink-0'>
                    <img
                      className='rounded-full w-11 h-11'
                      src='/images/users/joseph-mcfall.png'
                      alt='Josephimage'
                    />
                    <div className='absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 bg-red-600 border border-white rounded-full dark:border-gray-700'>
                      <svg
                        className='w-3 h-3 text-white'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          d='M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z'
                          clipRule='evenodd'></path>
                      </svg>
                    </div>
                  </div>
                  <div className='w-full pl-3'>
                    <div className='text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400'>
                      <span className='font-semibold text-gray-900 dark:text-white'>
                        Joseph Mcfall
                      </span>{' '}
                      and{' '}
                      <span className='font-medium text-gray-900 dark:text-white'>
                        141 others
                      </span>{' '}
                      love your story. See it and view more stories.
                    </div>
                    <div className='text-xs font-medium text-primary-700 dark:text-primary-400'>
                      44 minutes ago
                    </div>
                  </div>
                </a>
                <a
                  href='/'
                  className='flex px-4 py-3 border-b hover:bg-gray-100 dark:hover:bg-gray-600 dark:border-gray-600'>
                  <div className='flex-shrink-0'>
                    <img
                      className='rounded-full w-11 h-11'
                      src='/images/users/leslie-livingston.png'
                      alt='Leslieimage'
                    />
                    <div className='absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 bg-green-400 border border-white rounded-full dark:border-gray-700'>
                      <svg
                        className='w-3 h-3 text-white'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path
                          fillRule='evenodd'
                          d='M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z'
                          clipRule='evenodd'></path>
                      </svg>
                    </div>
                  </div>
                  <div className='w-full pl-3'>
                    <div className='text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400'>
                      <span className='font-semibold text-gray-900 dark:text-white'>
                        Leslie Livingston
                      </span>{' '}
                      mentioned you in a comment:{' '}
                      <span className='font-medium text-primary-700 dark:text-primary-500'>
                        @bonnie.green
                      </span>{' '}
                      what do you say?
                    </div>
                    <div className='text-xs font-medium text-primary-700 dark:text-primary-400'>
                      1 hour ago
                    </div>
                  </div>
                </a>
                <a
                  href='/'
                  className='flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-600'>
                  <div className='flex-shrink-0'>
                    <img
                      className='rounded-full w-11 h-11'
                      src='/images/users/robert-brown.png'
                      alt='Robertimage'
                    />
                    <div className='absolute flex items-center justify-center w-5 h-5 ml-6 -mt-5 bg-purple-500 border border-white rounded-full dark:border-gray-700'>
                      <svg
                        className='w-3 h-3 text-white'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'>
                        <path d='M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z'></path>
                      </svg>
                    </div>
                  </div>
                  <div className='w-full pl-3'>
                    <div className='text-gray-500 font-normal text-sm mb-1.5 dark:text-gray-400'>
                      <span className='font-semibold text-gray-900 dark:text-white'>
                        Robert Brown
                      </span>{' '}
                      posted a new video: Glassmorphism - learn how to implement
                      the new design trend.
                    </div>
                    <div className='text-xs font-medium text-primary-700 dark:text-primary-400'>
                      3 hours ago
                    </div>
                  </div>
                </a>
              </div>
              <a
                href='/'
                className='block py-2 text-base font-normal text-center text-gray-900 bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:text-white dark:hover:underline'>
                <div className='inline-flex items-center '>
                  <svg
                    className='w-5 h-5 mr-2'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path d='M10 12a2 2 0 100-4 2 2 0 000 4z'></path>
                    <path
                      fillRule='evenodd'
                      d='M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z'
                      clipRule='evenodd'></path>
                  </svg>
                  View all
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
